/**
 * @generated SignedSource<<12603c4d54ecfd1b171d900c03f14fdc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HostCardFragment$data = {
  readonly displayName: string;
  readonly username: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  readonly " $fragmentType": "HostCardFragment";
};
export type HostCardFragment$key = {
  readonly " $data"?: HostCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"HostCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HostCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "thumbnail",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "EntityProfilePicFragment"
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "0b132f88fdc00fe7f9f090f895b55896";

export default node;
